import React from 'react';
import usecaseImg1 from './images/whatsapp-formImg1.webp';
import usecaseImg2 from './images/whatsapp-formImg2.webp';
import usecaseImg3 from './images/whatsapp-formImg3.webp';
import usecaseImg4 from './images/whatsapp-formImg4.webp';
import usecaseImg5 from './images/whatsapp-formImg5.webp';

const Wp_Usecase = () => {
    const rows = [
        {
            title: 'Streamline Lead Qualification & Data Collection',
            desc:
                'Qualify leads at the source with chat-style forms. Capture clean data, enrich context, and auto-route to your CRM—no manual copy-paste.',
            points: [
                'Ask qualifying questions with buttons & validation',
                'Auto-enrich source, campaign & product interest',
                'Push to CRM, assign owners & set SLAs instantly',
            ],
            img: usecaseImg1,
        },
        {
            title: 'Conduct Surveys & Collect Feedback directly within WhatsApp',
            desc:
                'Run CSAT, NPS, and product surveys where users already chat. One-tap answers improve response rates and insights land in real time.',
            points: [
                'One-tap choices, multilingual templates',
                'Trigger after purchase/support; capture comments',
                'Track response rates; auto follow-ups for non-responders',
            ],
            img: usecaseImg2,
        },
        {
            title: 'Seamlessly Process Loan Applications',
            desc:
                'Pre-screen eligibility, collect KYC and income proofs, and move applicants forward—all inside WhatsApp with consent captured.',
            points: [
                'Capture PAN/Aadhaar (masked) & income details',
                'Upload docs and record consent in chat',
                'Score & route to RM; schedule callbacks instantly',
            ],
            img: usecaseImg3,
        },
        {
            title: 'Simplify Insurance Sales',
            desc:
                'Guide prospects from needs assessment to quote & documents. Reduce drop-offs with quick replies and in-chat reminders.',
            points: [
                'Collect age, coverage & premium preferences fast',
                'Share plan brochures & instant quotes in chat',
                'Gather KYC/medical docs; set renewal reminders',
            ],
            img: usecaseImg4,
        },
        {
            title: 'Collect Purchase Intent',
            desc:
                'Capture interest while it’s hot—sizes, colors, variants, and preferred delivery—then nudge users to checkout or handoff to sales.',
            points: [
                'One-tap interest, variant & quantity selection',
                'Send coupons/stock alerts; reduce drop-offs',
                'Route hot leads to reps or trigger COD flows',
            ],
            img: usecaseImg5,
        },
    ];

    return (
        <section
            className="py-4 position-relative"
            style={{ overflow: 'hidden' }}
        >
            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative"
                style={{
                    maxWidth: '74%',
                    zIndex: 1,
                    marginTop: '6rem'
                }}
            >
                {/* Heading */}
                <div>
                    <h2
                        style={{
                            fontSize: '2.5rem',
                            fontFamily: 'Inter',
                            fontWeight: 700,
                            color: '#242121ff',
                            lineHeight: 1.2,
                        }}
                    >
                        <span style={{ color: '#1DB954' }}>WhatsApp</span> Forms Unique Use Cases
                    </h2>
                    <p
                        style={{
                            fontSize: '1.1rem',
                            color: '#413e3e',
                            fontWeight: 300,
                            fontFamily: 'Poppins',
                            marginTop: '-0.5rem',
                        }}
                    >
                        Check out multiple ways you can use WhatsApp forms for your business
                    </p>
                </div>

                {/* Alternating rows */}
                <div style={{ marginTop: 50 }}>
                    {rows.map((f, i) => (
                        <div className={`wp-row ${i % 2 !== 0 ? 'reverse' : ''}`} key={f.title}>
                            {/* Image */}
                            <div className="wp-img">
                                <img src={f.img} alt={f.title} />
                            </div>

                            {/* Content */}
                            <div className="wp-content">
                                <h3 className="wp-title">{f.title}</h3>
                                <p className="wp-desc">{f.desc}</p>

                                {/* Points list */}
                                {Array.isArray(f.points) && f.points.length > 0 && (
                                    <ul className="wp-points">
                                        {f.points.map((pt, idx) => (
                                            <li key={idx} className="wp-point">
                                                <span className="wp-bullet" aria-hidden="true">
                                                    {/* dark blue check inside light blue circle */}
                                                    <svg width="14"
                                                        height="14"
                                                        viewBox="0 0 20 20"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M5 10.5l3 3L15 6.5"
                                                            stroke="#054E91"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </span>
                                                {pt}
                                            </li>
                                        ))}
                                    </ul>
                                )}

                                {/* CTA only if provided */}
                                {f.cta && (
                                    <button className="wp-btn" type="button">
                                        {f.cta}
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <style>{`
        .wp-row{
          display:flex; 
          align-items:center; 
          justify-content:space-between; 
          gap:48px;
          margin-bottom:80px;
        }
        .wp-row.reverse{
          flex-direction:row-reverse;
        }
        .wp-img{ 
          flex:1; 
          text-align:center; 
        }
        .wp-img img{ 
          width:100%; 
          max-width:520px; 
          border-radius:14px; 
        }
        .wp-content{ flex:1; }
        .wp-title{
          font-size:1.6rem; 
          font-weight:600; 
          font-family:lato;
          color: #242121ff;
          line-height:1.2; 
          margin: 0 0 8px 0;
        }
        .wp-desc{
          font-size:1.1rem; 
          font-family:lato;
          font-weight:400;
          line-height:1.22; 
          color: #413e3eff; 
          margin:0 0 14px 0;
        }

        /* Points list: light-blue circle + dark-blue check */
        .wp-points{
          margin: 0 0 16px 0;
          padding: 0;
          list-style: none;
          display: grid;
          gap: 8px;
        }
        .wp-point{
          display: flex;
          align-items: center;
          gap: 10px;
          font-family: lato;
          font-size: 1rem;
          line-height: 1.3;
          color: #413e3eff;
        }
        .wp-bullet{
          flex: 0 0 24px;
          width: 24px; 
          height: 24px;
          border-radius: 50%;
          display: grid; place-items: center;
          background: #eaf2ff;       
          border: 1px solid #d7e5ff;  
        }
        .wp-bullet svg{ display:block; }

        .wp-btn{
          display:inline-block; 
          padding:10px 16px; 
          border-radius:10px;
          background:#1d78b9ff; 
          color:#fff; 
          font-weight:600; 
          font-family:Inter,system-ui;
          border:none; 
          cursor:pointer; 
          transition:transform .12s ease, box-shadow .12s ease;
        }
        .wp-btn:active{ transform:translateY(1px); }

        @media (max-width: 900px){
          .wp-row, .wp-row.reverse{ 
            flex-direction:column; 
            text-align:left; 
            gap:24px; 
            margin-bottom:56px; 
          }
          .wp-img img{ max-width:100%; }
        }
      `}</style>
        </section>
    );
};

export default Wp_Usecase;
